/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_DriverInputs */

const vi_trip_driver = /** @type {(inputs: Trip_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài xế`)
};

/**

* @param {Trip_DriverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_driver = /** @type {((inputs?: Trip_DriverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_DriverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_driver(inputs)
});